module.exports = __webpack_public_path__ + "img/蒙版组 48.33c9b44d.jpg";